import { Box, Typography, Breadcrumbs, Link as MuiLink } from "@mui/material"
import { Link } from "react-router-dom"
import DashboardLayout from "../components/DashboardLayout"
import ProfileForm from "../components/profile/ProfileForm"

const ProfilePage = () => {
  return (
    <DashboardLayout>
      <Box sx={{ maxWidth: 800, mx: "auto" }}>
        {/* Breadcrumbs */}
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <MuiLink component={Link} to="/dashboard" color="inherit" underline="hover">
            Dashboard
          </MuiLink>
          <Typography color="text.primary">Profile</Typography>
        </Breadcrumbs>

        {/* Page Title */}
        <Typography variant="h4" component="h1" gutterBottom>
          Profile Settings
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Manage your account information and profile settings
        </Typography>

        <ProfileForm />
      </Box>
    </DashboardLayout>
  )
}

export default ProfilePage
